export default __webpack_public_path__ + "static/media/verypoor_active.be012755.svg";